export enum NavigationSidebarVariants {
  primary = 'primary',
  secondary = 'secondary',
  light = 'light',
}
